// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


*{
    box-sizing: border-box;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    overflow-x: hidden;
}


.linkItem {
    text-decoration: none;
    color: black;
    transition: color 0.3s ease; 
}


.linkItem:hover {
    color: gold;
}


.linkItem.active {
    color: gold;
}




.logo {
  
    overflow: hidden;
    
}
.logo img{
   
   
}

.loggedBtn h3{
   
    
   display: flex;
   align-items: center;
   gap: 3px;
}

.logoutBtn{
    background-color: black;
    display: flex;
    align-items: center;
    color: white;
    position: absolute;
    z-index: 6;
    right: 30px;
    padding: 10px;
    width: 180px;
    text-align: center;
    border-radius: 3px;
}

.logoutBtn .listItem{
    color: white;

    
 
}
.logoutBtn p{
  
    padding: 0;
    margin: 0;
}
.logoutBtn p:hover{
  
    color: gold;
}


.fontLogoutICon{
   
    background-color: rgb(39, 37, 37);
    color: white;
    font-size: 10px;
    padding: 5px;
    border-radius: 50%;
}




.NavWhole{
   
   
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: black;
    font-weight: 700;
  
    background-color: #f7f7f7;
   

}



.scrollCover{ 
 
    
    position: fixed;
   
    -webkit-backface-visibility: hidden;
    transform: translateZ(0);
    padding: 0;
    margin-left: 15px;
    margin-right: 30px;
    font-size: 12px;
    line-height: 1.9rem;
    overflow: hidden;
    border-radius: 15px;
    -webkit-border-radius: 15px; /* Add this */

    top: 5px;
    left: 0;
    
    width: 100% !important;
    z-index: 5; 

    
}

.resNav{
    display: none;
}
.scrollCover button{ 
 
    
  border: none;
  background-color: inherit;

    
}

.scrollCover .listItems{

    background-color: #f7f7f7;
    margin-right: 30px;
    border-radius: 15px;
    
}

.listItems ul{

    list-style: none;
    display: flex;
    display: -webkit-flex;
    margin: 0;
    padding: 0;
    
    align-items: center;
    

}

.toggle .fontawesomIcons{
    font-size: 1.3rem;
  
}
.resNav img{
    margin: 5px 0;
    width: 100%;
   
    object-fit: cover;
    -webkit-object-fit: cover; /* Add this */
}

.listItems{

    display: flex;
    display: -webkit-flex;
    padding: 5px 30px;
    align-items: center;
    justify-content: space-between;
}

.listItems img{
    margin: 3px 0;
    width: 100%;
   
    transform: scale(1.2); 
    height: 70px;
    object-fit: cover;
    -webkit-object-fit: cover; /* Add this */
    
}
.listItems li{
    padding: 0;
    margin: 0;
    list-style: none;

    cursor: pointer;

}
.listItems .secItem li{
  margin-right: 20px;
  font-size: 1.1rem;

}

.listItems .buttons button{
    min-width: 150px;
    padding: 10px;
    cursor: pointer;
}

.dropView{
   
    position: absolute;
    margin-left: 30px;
   width: 100%;
   padding-right: 30px;
   

}
.noDrop{
    display: none;
}

.SecResDrop{
    display: none;
}

.NavWhole .dropCover{
    display: flex;
    display: -webkit-flex;

    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    justify-content: space-evenly;
    font-size: 12px;
    font-weight: 500;
    line-height: 30px;
    color: black;
    margin-right: 30px;
    margin-top: 10px;
   
    border-radius: 15px;
    background-color: #f7f7f7;

}
.NavWhole .dropCover li{
   cursor: pointer;

}
.scrollCover .dropCover{
    display: flex;
    display: -webkit-flex;
    justify-content: space-evenly;
    margin-right: 45px;
    margin-top: 10px;
    background-color: #f7f7f7;
    border-radius: 15px;

}
.dropView ul{

    
    list-style: none;
    padding: 0 10px;
    
   
}
.dropView li{
    cursor: pointer;
   margin: 0;
   padding: 0;
   
}

.secDropCover{
    display: none;
}


@media screen and (max-width: 730px){   


    .logo {
    
    width: 70px;
   }
    /* .logo img{
    object-fit: cover;
   } */
   .logo img {
    object-fit: cover;
    -webkit-object-fit: cover; /* Add this */
   
}

    .scrollCover{
        width: 100%;
    }
    .scrollCover .NavWhole{
        display: none;
    }
    .NavWhole .resNav{
        display: flex;
        display: -webkit-flex;
        align-items: center;
        margin-right: 30px;
        padding-left: 10px;
       
       
      
        justify-content: space-between;
    }

    .NavWhole .listItems{
     display: none;
    }
    .scrollCover .listItems{
     display: none;
    }


    .scrollCover .resNav{
        display: flex;
        display: -webkit-flex;
        align-items: center;
        padding-left: 10px;
        margin-right: 30px;
        border-radius: 15px;
        background-color: white;
        justify-content: space-between;
    }
   
    .scrollCover .resNav .toggle{
       margin-right: 40px;
    }

    .scrollCover.fontawesomIcons{
      
        margin: 0;
        background-color: antiquewhite;
        z-index: 40;
      
    }
   
    /* .scrollCover ul{
        width: 100%;
        display: flex;
        justify-content: space-between;
       
    } */
    .scrollCover ul {
        display: flex;
        justify-content: space-between;
    }
    
    .scrollCover li{
        margin: 0;
        padding: 0;
      
    }

    .scrollCover .listItems{
     
    }

    .listItems .serviceItem{
        display: none;
    }
    .listItems .buttons{
        display: none;
    }
    .listItems button{
        display: none;
    }

    .dropView{
        display: none;
    }

    .SecResDrop{

        display: block;
        margin-top: 5px;
        margin-left: 15px;
       
    }
    .scrollCover .SecResDrop{

        display: block;
        margin-left: 1px;
       
    }
    .SecResDrop ul{

       margin: 20px 0;
       padding: 0;
       min-height: 300px;
        width: 100%;
       display: flex;
       display: -webkit-flex;
       align-items: center;
       justify-content: space-between;
       flex-direction: column;

     
    }
    .SecResDrop li{
       
        margin: 0;
        padding: 0;
    }
    .secDropCover{
        color: black;
        margin-right: 30px;
        display: flex;
        background-color: #f7f7f7;
        border-radius: 15px;
    }
    .secDropCover button{
        border: .1px solid #003300;
        color: black;
        font-size: 1rem;
        padding: 12px 36px;
        border-radius: 3px;
    }

    .noSecDrop{
        display: none;
        
    }

 
    

   
    
}`, "",{"version":3,"sources":["webpack://./src/Components/NavBar/NavBar.css"],"names":[],"mappings":";;;AAGA;IACI,sBAAsB;IACtB,4DAA4D;IAC5D,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;IACrB,YAAY;IACZ,2BAA2B;AAC/B;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;;;AAKA;;IAEI,gBAAgB;;AAEpB;AACA;;;AAGA;;AAEA;;;GAGG,aAAa;GACb,mBAAmB;GACnB,QAAQ;AACX;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;;;;AAIhB;AACA;;IAEI,UAAU;IACV,SAAS;AACb;AACA;;IAEI,WAAW;AACf;;;AAGA;;IAEI,iCAAiC;IACjC,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;;;;AAKA;;;IAGI,4DAA4D;IAC5D,YAAY;IACZ,gBAAgB;;IAEhB,yBAAyB;;;AAG7B;;;;AAIA;;;IAGI,eAAe;;IAEf,mCAAmC;IACnC,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B,EAAE,aAAa;;IAE1C,QAAQ;IACR,OAAO;;IAEP,sBAAsB;IACtB,UAAU;;;AAGd;;AAEA;IACI,aAAa;AACjB;AACA;;;EAGE,YAAY;EACZ,yBAAyB;;;AAG3B;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,UAAU;;IAEV,mBAAmB;;;AAGvB;;AAEA;IACI,iBAAiB;;AAErB;AACA;IACI,aAAa;IACb,WAAW;;IAEX,iBAAiB;IACjB,yBAAyB,EAAE,aAAa;AAC5C;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;;IAEX,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB,EAAE,aAAa;;AAE5C;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;;IAEhB,eAAe;;AAEnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;GAClB,WAAW;GACX,mBAAmB;;;AAGtB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;;IAErB,4DAA4D;IAC5D,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;;IAEhB,mBAAmB;IACnB,yBAAyB;;AAE7B;AACA;GACG,eAAe;;AAElB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;;AAEvB;AACA;;;IAGI,gBAAgB;IAChB,eAAe;;;AAGnB;AACA;IACI,eAAe;GAChB,SAAS;GACT,UAAU;;AAEb;;AAEA;IACI,aAAa;AACjB;;;AAGA;;;IAGI;;IAEA,WAAW;GACZ;IACC;;MAEE;GACH;IACC,iBAAiB;IACjB,yBAAyB,EAAE,aAAa;;AAE5C;;IAEI;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;;;;QAIlB,8BAA8B;IAClC;;IAEA;KACC,aAAa;IACd;IACA;KACC,aAAa;IACd;;;IAGA;QACI,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,8BAA8B;IAClC;;IAEA;OACG,kBAAkB;IACrB;;IAEA;;QAEI,SAAS;QACT,8BAA8B;QAC9B,WAAW;;IAEf;;IAEA;;;;;OAKG;IACH;QAEI,aAAa;QAEb,8BAA8B;IAClC;;IAEA;QACI,SAAS;QACT,UAAU;;IAEd;;IAEA;;IAEA;;IAEA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,cAAc;QACd,eAAe;QACf,iBAAiB;;IAErB;IACA;;QAEI,cAAc;QACd,gBAAgB;;IAEpB;IACA;;OAEG,cAAc;OACd,UAAU;OACV,iBAAiB;QAChB,WAAW;OACZ,aAAa;OACb,qBAAqB;OACrB,mBAAmB;OACnB,8BAA8B;OAC9B,sBAAsB;;;IAGzB;IACA;;QAEI,SAAS;QACT,UAAU;IACd;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,yBAAyB;QACzB,mBAAmB;IACvB;IACA;QACI,0BAA0B;QAC1B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;;IAEjB;;;;;;;AAOJ","sourcesContent":["\n\n\n*{\n    box-sizing: border-box;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    overflow-x: hidden;\n}\n\n\n.linkItem {\n    text-decoration: none;\n    color: black;\n    transition: color 0.3s ease; \n}\n\n\n.linkItem:hover {\n    color: gold;\n}\n\n\n.linkItem.active {\n    color: gold;\n}\n\n\n\n\n.logo {\n  \n    overflow: hidden;\n    \n}\n.logo img{\n   \n   \n}\n\n.loggedBtn h3{\n   \n    \n   display: flex;\n   align-items: center;\n   gap: 3px;\n}\n\n.logoutBtn{\n    background-color: black;\n    display: flex;\n    align-items: center;\n    color: white;\n    position: absolute;\n    z-index: 6;\n    right: 30px;\n    padding: 10px;\n    width: 180px;\n    text-align: center;\n    border-radius: 3px;\n}\n\n.logoutBtn .listItem{\n    color: white;\n\n    \n \n}\n.logoutBtn p{\n  \n    padding: 0;\n    margin: 0;\n}\n.logoutBtn p:hover{\n  \n    color: gold;\n}\n\n\n.fontLogoutICon{\n   \n    background-color: rgb(39, 37, 37);\n    color: white;\n    font-size: 10px;\n    padding: 5px;\n    border-radius: 50%;\n}\n\n\n\n\n.NavWhole{\n   \n   \n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    color: black;\n    font-weight: 700;\n  \n    background-color: #f7f7f7;\n   \n\n}\n\n\n\n.scrollCover{ \n \n    \n    position: fixed;\n   \n    -webkit-backface-visibility: hidden;\n    transform: translateZ(0);\n    padding: 0;\n    margin-left: 15px;\n    margin-right: 30px;\n    font-size: 12px;\n    line-height: 1.9rem;\n    overflow: hidden;\n    border-radius: 15px;\n    -webkit-border-radius: 15px; /* Add this */\n\n    top: 5px;\n    left: 0;\n    \n    width: 100% !important;\n    z-index: 5; \n\n    \n}\n\n.resNav{\n    display: none;\n}\n.scrollCover button{ \n \n    \n  border: none;\n  background-color: inherit;\n\n    \n}\n\n.scrollCover .listItems{\n\n    background-color: #f7f7f7;\n    margin-right: 30px;\n    border-radius: 15px;\n    \n}\n\n.listItems ul{\n\n    list-style: none;\n    display: flex;\n    display: -webkit-flex;\n    margin: 0;\n    padding: 0;\n    \n    align-items: center;\n    \n\n}\n\n.toggle .fontawesomIcons{\n    font-size: 1.3rem;\n  \n}\n.resNav img{\n    margin: 5px 0;\n    width: 100%;\n   \n    object-fit: cover;\n    -webkit-object-fit: cover; /* Add this */\n}\n\n.listItems{\n\n    display: flex;\n    display: -webkit-flex;\n    padding: 5px 30px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.listItems img{\n    margin: 3px 0;\n    width: 100%;\n   \n    transform: scale(1.2); \n    height: 70px;\n    object-fit: cover;\n    -webkit-object-fit: cover; /* Add this */\n    \n}\n.listItems li{\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    cursor: pointer;\n\n}\n.listItems .secItem li{\n  margin-right: 20px;\n  font-size: 1.1rem;\n\n}\n\n.listItems .buttons button{\n    min-width: 150px;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.dropView{\n   \n    position: absolute;\n    margin-left: 30px;\n   width: 100%;\n   padding-right: 30px;\n   \n\n}\n.noDrop{\n    display: none;\n}\n\n.SecResDrop{\n    display: none;\n}\n\n.NavWhole .dropCover{\n    display: flex;\n    display: -webkit-flex;\n\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    justify-content: space-evenly;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 30px;\n    color: black;\n    margin-right: 30px;\n    margin-top: 10px;\n   \n    border-radius: 15px;\n    background-color: #f7f7f7;\n\n}\n.NavWhole .dropCover li{\n   cursor: pointer;\n\n}\n.scrollCover .dropCover{\n    display: flex;\n    display: -webkit-flex;\n    justify-content: space-evenly;\n    margin-right: 45px;\n    margin-top: 10px;\n    background-color: #f7f7f7;\n    border-radius: 15px;\n\n}\n.dropView ul{\n\n    \n    list-style: none;\n    padding: 0 10px;\n    \n   \n}\n.dropView li{\n    cursor: pointer;\n   margin: 0;\n   padding: 0;\n   \n}\n\n.secDropCover{\n    display: none;\n}\n\n\n@media screen and (max-width: 730px){   \n\n\n    .logo {\n    \n    width: 70px;\n   }\n    /* .logo img{\n    object-fit: cover;\n   } */\n   .logo img {\n    object-fit: cover;\n    -webkit-object-fit: cover; /* Add this */\n   \n}\n\n    .scrollCover{\n        width: 100%;\n    }\n    .scrollCover .NavWhole{\n        display: none;\n    }\n    .NavWhole .resNav{\n        display: flex;\n        display: -webkit-flex;\n        align-items: center;\n        margin-right: 30px;\n        padding-left: 10px;\n       \n       \n      \n        justify-content: space-between;\n    }\n\n    .NavWhole .listItems{\n     display: none;\n    }\n    .scrollCover .listItems{\n     display: none;\n    }\n\n\n    .scrollCover .resNav{\n        display: flex;\n        display: -webkit-flex;\n        align-items: center;\n        padding-left: 10px;\n        margin-right: 30px;\n        border-radius: 15px;\n        background-color: white;\n        justify-content: space-between;\n    }\n   \n    .scrollCover .resNav .toggle{\n       margin-right: 40px;\n    }\n\n    .scrollCover.fontawesomIcons{\n      \n        margin: 0;\n        background-color: antiquewhite;\n        z-index: 40;\n      \n    }\n   \n    /* .scrollCover ul{\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n       \n    } */\n    .scrollCover ul {\n        display: -webkit-flex;\n        display: flex;\n        -webkit-justify-content: space-between;\n        justify-content: space-between;\n    }\n    \n    .scrollCover li{\n        margin: 0;\n        padding: 0;\n      \n    }\n\n    .scrollCover .listItems{\n     \n    }\n\n    .listItems .serviceItem{\n        display: none;\n    }\n    .listItems .buttons{\n        display: none;\n    }\n    .listItems button{\n        display: none;\n    }\n\n    .dropView{\n        display: none;\n    }\n\n    .SecResDrop{\n\n        display: block;\n        margin-top: 5px;\n        margin-left: 15px;\n       \n    }\n    .scrollCover .SecResDrop{\n\n        display: block;\n        margin-left: 1px;\n       \n    }\n    .SecResDrop ul{\n\n       margin: 20px 0;\n       padding: 0;\n       min-height: 300px;\n        width: 100%;\n       display: flex;\n       display: -webkit-flex;\n       align-items: center;\n       justify-content: space-between;\n       flex-direction: column;\n\n     \n    }\n    .SecResDrop li{\n       \n        margin: 0;\n        padding: 0;\n    }\n    .secDropCover{\n        color: black;\n        margin-right: 30px;\n        display: flex;\n        background-color: #f7f7f7;\n        border-radius: 15px;\n    }\n    .secDropCover button{\n        border: .1px solid #003300;\n        color: black;\n        font-size: 1rem;\n        padding: 12px 36px;\n        border-radius: 3px;\n    }\n\n    .noSecDrop{\n        display: none;\n        \n    }\n\n \n    \n\n   \n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
